<template>
  <div>
    <b-spinner variant="warning" class="m-5" style="width: 3rem; height: 3rem;" v-if="showSpinner"></b-spinner>
    <div id="idLists" v-if="!showSpinner">
      <b-form-row>
        <b-card id="idTreatmentPlanRequestsCard" title-tag="h5" title="Treatment Plan Requests">
          <b-table
            id="idTreatmentPlanRequestsTable"
            show-empty
            small
            fixed
            head-variant="light"
            outlined
            hover
            selectable
            :fields="treatmentPlanRequestsFields"
            :items="attachedTreatmentPlanRequests"
            @row-clicked="handleTprClicked"
          ></b-table>
        </b-card>
      </b-form-row>
      <b-form-row>
        <b-card id="idSurgicalCaseHistoryCard" title-tag="h5" title="Surgical Case History">
          <b-table
            id="idSurgicalCaseHistoryTable"
            show-empty
            head-variant="light"
            small
            fixed
            outlined
            :fields="surgicalCaseHistoryFields"
            :items="surgicalCaseHistory"
          ></b-table>
        </b-card>
      </b-form-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["surgicalCase"],
  data() {
    return {
      showSpinner: true,
      treatmentPlanRequestsFields: [
        { key: "Treatment Plan Request ID" },
        { key: "Status" },
        { key: "Procedure Type", formatter: this.formatProcedureType },
        { key: "Surgery Start Date" }
      ],
      surgicalCaseHistoryFields: [
        "Date",
        "Field",
        "User",
        "Original Value",
        "New Value"
      ],
      attachedTreatmentPlanRequests: null,
      surgicalCaseHistory: null
    };
  },
  methods: {
    formatProcedureType(value) {
      if (!value) return "";
      return this.$store.getters.getProcedureText(value)
    },
    handleTprClicked(item) {
      this.$emit("tprClicked", item["Treatment Plan Request ID"]);
    }
  },
  created() {
    var promises = this.surgicalCase.treatmentPlanRequests.map(async tpr => {
      return this.$treatmentPlanRequestsApi.treatmentplanrequestsIdGet(
        tpr.entityId
      );
    });
    Promise.all(promises).then(results => {
      if (results.length) {
        this.attachedTreatmentPlanRequests = results.map(response => {
          return {
            "Treatment Plan Request ID": response.externalReference,
            Status: response.metadata.commentedRequestState.requestState,
            "Procedure Type": response.treatment?.application?.applicationType
              ? response.treatment.application.applicationType
              : "",
            "Surgery Start Date": response?.treatment?.surgeryDate
              ? moment(response.treatment.surgeryDate).utc().format("M/D/YYYY")
              : moment(this.surgicalCase.surgeryStartDateTime).utc().format(
                  "M/D/YYYY"
                )
          };
        });
      }
      this.showSpinner = false;
    });
  }
};
</script>

<style scoped>
.card {
  margin: 2rem 0rem;
  text-align: left;
}
</style>